/** English values come from per-surface JSON and must match the Finnish key set. */

import { adminEn } from './en/admin.js';
import { adminAnalyticsEn } from './en/adminAnalytics.js';
import { cmsEn } from './en/cms.js';
import { cmsArchiveEn } from './en/cmsArchive.js';
import { cmsArticleEn } from './en/cmsArticle.js';
import { cmsBannerEn } from './en/cmsBanner.js';
import { cmsBenefitEn } from './en/cmsBenefit.js';
import { cmsCatalogEn } from './en/cmsCatalog.js';
import { cmsContentLocaleEn } from './en/cmsContentLocale.js';
import { cmsCopyUnitToLocaleEn } from './en/cmsCopyUnitToLocale.js';
import { cmsCreateEn } from './en/cmsCreate.js';
import { cmsDiscardStagedEditEn } from './en/cmsDiscardStagedEdit.js';
import { cmsDuplicateEn } from './en/cmsDuplicate.js';
import { cmsEditorFormEn } from './en/cmsEditorForm.js';
import { cmsHomeCardEn } from './en/cmsHomeCard.js';
import { cmsLifecycleConfirmEn } from './en/cmsLifecycleConfirm.js';
import { cmsLifecycleToastEn } from './en/cmsLifecycleToast.js';
import { cmsOrderEn } from './en/cmsOrder.js';
import { cmsPreviewEn } from './en/cmsPreview.js';
import { cmsRichTextEn } from './en/cmsRichText.js';
import { cmsScheduleEn } from './en/cmsSchedule.js';
import { cmsScheduleRowMarkerEn } from './en/cmsScheduleRowMarker.js';
import { cmsStandaloneCreateEn } from './en/cmsStandaloneCreate.js';
import { cmsUploadEn } from './en/cmsUpload.js';
import { cmsVideoListingEn } from './en/cmsVideoListing.js';
import { commonEn } from './en/common.js';
import { homeEn } from './en/home.js';
import { memberEn } from './en/member.js';
import { memberMessagingCatalogueEn } from './en/memberMessagingCatalogue.js';
import { memberMessagingComposeEn } from './en/memberMessagingCompose.js';
import { myCasesEn } from './en/myCases.js';
import { myDataDeletionEn } from './en/myDataDeletion.js';
import { myDataExportEn } from './en/myDataExport.js';
import { onboardingEn } from './en/onboarding.js';
import { shellEn } from './en/shell.js';
import type { MessageKeys } from './fi.js';

export const en: Record<MessageKeys, string> = {
  ...commonEn,
  ...homeEn,
  ...shellEn,
  ...memberEn,
  ...memberMessagingComposeEn,
  ...myCasesEn,
  ...myDataDeletionEn,
  ...myDataExportEn,
  ...memberMessagingCatalogueEn,
  ...onboardingEn,
  ...cmsEn,
  ...cmsArchiveEn,
  ...cmsBenefitEn,
  ...cmsCatalogEn,
  ...cmsCreateEn,
  ...cmsEditorFormEn,
  ...cmsHomeCardEn,
  ...cmsOrderEn,
  ...cmsPreviewEn,
  ...cmsScheduleEn,
  ...cmsVideoListingEn,
  ...cmsDiscardStagedEditEn,
  ...cmsContentLocaleEn,
  ...cmsCopyUnitToLocaleEn,
  ...cmsDuplicateEn,
  ...cmsBannerEn,
  ...cmsArticleEn,
  ...cmsRichTextEn,
  ...cmsLifecycleToastEn,
  ...cmsLifecycleConfirmEn,
  ...cmsScheduleRowMarkerEn,
  ...cmsStandaloneCreateEn,
  ...cmsUploadEn,
  ...adminEn,
  ...adminAnalyticsEn,
};
